import React from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      onClick={toTop}
      data-testid="scroll-to-top"
      aria-label="Scroll to top"
      className={`fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 flex items-center gap-2 bg-mrn-wood hover:bg-mrn-terracotta text-mrn-cream rounded-full shadow-lg shadow-black/20 pl-3 pr-4 py-3 transition-all duration-300 hover:-translate-y-0.5 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <ArrowUp size={18} strokeWidth={2} />
      <span className="text-sm font-medium hidden sm:block">Top</span>
    </button>
  );
}
